module.exports = __webpack_public_path__ + "img/hero-school@2x.66e66dc5.webp";